import Link from '@material-ui/core/Link';
import Email from '@pe-libs/react-components/build/components/PeIcons/Email.svg';
import Facebook from '@pe-libs/react-components/build/components/PeIcons/Facebook.svg';
import LinkedIn from '@pe-libs/react-components/build/components/PeIcons/LinkedIn.svg';
import Twitter from '@pe-libs/react-components/build/components/PeIcons/Twitter.svg';
import Xing from '@pe-libs/react-components/build/components/PeIcons/Xing.svg';
import PeLink from '@pe-libs/react-components/build/components/PeLink';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getProfilePublicData } from '#modules/defaultLandingReferral/selectors';
import messages from './messages';
import useStyles from './styles';

type Props = { link: string };

const SocialButtons: FC<Props> = ({ link }) => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const data = useSelector(getProfilePublicData);
  const profileName = data.attributes.title;
  const encodedLink = encodeURIComponent(link);
  const socialText = encodeURIComponent(`${formatMessage(messages.emailContent, { profileName })} ${link}`);
  const twitterText = encodeURIComponent(`${formatMessage(messages.emailContent, { profileName })}`);

  return (
    <div className={styles.container}>
      <PeLink href={`https://www.facebook.com/sharer.php?u=${encodedLink}`} target="_blank">
        <Facebook />
      </PeLink>
      <PeLink href={`https://twitter.com/intent/tweet?url=${encodedLink}&text=${twitterText}`} target="_blank">
        <Twitter />
      </PeLink>
      <PeLink href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedLink}`} target="_blank">
        <LinkedIn />
      </PeLink>
      <PeLink href={`https://www.xing.com/spi/shares/new?url=${encodedLink}`} target="_blank">
        <Xing />
      </PeLink>
      <Link
        target="_blank"
        href={`mailto:?subject=${formatMessage(messages.emailSubject, { profileName })}
        &body=${socialText}`}
      >
        <Email />
      </Link>
    </div>
  );
};

export default SocialButtons;
